'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm._m(0);
  },
  staticRenderFns: [function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "icon-loading"
    }, [_c('i'), _c('i'), _c('i'), _c('i'), _c('i'), _c('i'), _vm._v(" "), _c('i'), _c('i'), _c('i'), _c('i'), _c('i'), _c('i')]);
  }],
  name: 'icon-loading'
});

exports.default = index;
